import React from "../_snowpack/pkg/react.js";
import SimplePage from "../components/simple-page.js";
import AboutPage from "../components/about-page.js";
import HelpPage from "../components/help-page.js";
import FormPage from "../components/form-page.js";
import ContentPage from "../components/content-page.js";
import ContactPage from "../components/contact-page.js";
import SuccessPage from "../components/success-page.js";
import App from "../components/app.js";
export default function Page(props) {
  const {content, ...rest} = props;
  return /* @__PURE__ */ React.createElement(App, {
    ...props
  }, /* @__PURE__ */ React.createElement(Component, {
    page: content,
    ...rest
  }));
}
function Component(props) {
  const {page, ...rest} = props;
  if (page.component === "simple_page") {
    return /* @__PURE__ */ React.createElement(SimplePage, {
      ...page
    });
  }
  if (page.component === "about_page") {
    return /* @__PURE__ */ React.createElement(AboutPage, {
      ...page
    });
  }
  if (page.component === "help_page") {
    return /* @__PURE__ */ React.createElement(HelpPage, {
      ...page
    });
  }
  if (page.component === "form_page") {
    return /* @__PURE__ */ React.createElement(FormPage, {
      ...page
    });
  }
  if (page.component === "contact_page") {
    return /* @__PURE__ */ React.createElement(ContactPage, {
      ...page
    });
  }
  if (page.component === "content_page") {
    return /* @__PURE__ */ React.createElement(ContentPage, {
      ...page
    });
  }
  if (page.component === "success_page") {
    return /* @__PURE__ */ React.createElement(SuccessPage, {
      ...page,
      ...rest
    });
  }
  return null;
}
